import App from "./App.svelte";

let comments = document.getElementById("comments");
let appUrl = comments.getAttribute("data-url") || "localhost:8080";
let supabaseUrl = comments.getAttribute("supabase-url");
let anonKey = comments.getAttribute("anon-key");

const app = new App({
  target: comments,
  props: {
    appUrl: appUrl,
    supabaseUrl: supabaseUrl,
    anonKey: anonKey
  },
});

export default app;
